'use client';

import React from 'react';

import NavMenusContext from './NavMenusContext';

// Provides server-fetched getNavigationMenus data to the footer subtree so
// ConsumerMobileFooterMenu resolves without an Apollo useSuspenseQuery call.
// `value` is the full fetchFromAlexandria() result — same shape as Apollo `data`.
const NavMenusProvider = ({ value = null, children }) => (
  <NavMenusContext.Provider value={value}>{children}</NavMenusContext.Provider>
);

export default NavMenusProvider;
